import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";
import type { User } from "../../api/types";

export const fetchUsers = createAsyncThunk("users/fetch", async () => {
  const res = await api<{ ok: true; users: User[] }>("/admin/users", { method: "GET" });
  return res.users;
});

export const adminSetStatus = createAsyncThunk("users/setStatus", async (p: { userId: string; status: string; }) => {
  await api<{ ok: true }>("/admin/set-status", { method: "POST", body: JSON.stringify(p) });
  return p;
});

const slice3 = createSlice({
  name: "users",
  initialState: { list: [] as User[], loading: false, error: "" },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchUsers.pending, s => { s.loading = true; })
     .addCase(fetchUsers.fulfilled, (s,a) => { s.loading = false; s.list = a.payload; })
     .addCase(fetchUsers.rejected, (s,a) => { s.loading = false; s.error = a.error.message || ""; })
     .addCase(adminSetStatus.fulfilled, (s,a) => { const u = s.list.find(x=>x.id===a.payload.userId); if (u) u.status = a.payload.status; });
  }
});
export default slice3.reducer;